import type { OpenSearchState } from './type'

export const initOpenSearchState: OpenSearchState = {
  keyword: '',
  autoCompleteKeyword: '',
  autoComplete: [],
}
